import React from 'react';
import { useTheme } from "@/lib/ThemeProvider.tsx";

interface MapStylePreviewProps {
  styleName: 'default' | 'dark' | 'light' | 'theme_color';
  height?: string;
  width?: string;
}

const MapStylePreview: React.FC<MapStylePreviewProps> = ({
  styleName,
  height = "150px",
  width = "100%"
}) => {

  const { isDark } = useTheme();

  const features = {
    theme_color: isDark ? {
      water: 'rgba(0, 0, 0, 0.8)',
      land: 'rgba(0, 0, 0, 0.9)',
      road: 'rgba(255, 255, 255, 0.15)',
      park: 'rgba(0, 40, 0, 0.4)',
    } : {
      water: 'rgba(80, 160, 240, 0.8)',
      land: '#f7f7f7',
      road: '#f5f5f5',
      park: 'rgba(0, 255, 144, 0.2)',
    },
    default: {
      water: '#a5d7e0',
      land: '#efebe2',
      road: '#ffffff',
      park: '#bad294',
    },
    dark: {
      water: 'rgba(0, 0, 0, 0.8)',
      land: 'rgba(0, 0, 0, 0.9)',
      road: 'rgba(255, 255, 255, 0.15)',
      park: 'rgba(0, 40, 0, 0.4)',
    },
    light: {
      water: 'rgba(80, 160, 240, 0.8)',
      land: '#f7f7f7',
      road: '#f5f5f5',
      park: 'rgba(0, 255, 144, 0.2)',
    },
  };

  const currentStyle = features[styleName];

  return (
    <div
      style={{
        height,
        width,
        borderRadius: '6px',
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: currentStyle.land,
      }}
      className="border"
    >
      {/* Water body */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: '30%',
        height: '45%',
        backgroundColor: currentStyle.water,
        borderTopRightRadius: '100%',
      }} />

      {/* Small island */}
      <div style={{
        position: 'absolute',
        bottom: '10%',
        left: '20%',
        width: '15%',
        height: '10%',
        backgroundColor: currentStyle.land,
        borderRadius: '50%',
      }} />

      {/* Main road */}
      <div style={{
        position: 'absolute',
        top: '30%',
        left: 0,
        right: 0,
        height: '10%',
        backgroundColor: currentStyle.road,
      }} />

      {/* Vertical road */}
      <div style={{
        position: 'absolute',
        top: '30%',
        bottom: 0,
        left: '60%',
        width: '8%',
        backgroundColor: currentStyle.road,
      }} />

      {/* Park */}
      <div style={{
        position: 'absolute',
        top: '10%',
        right: '10%',
        width: '25%',
        height: '15%',
        backgroundColor: currentStyle.park,
        borderRadius: '5px',
      }} />
    </div>
  );
};

export default MapStylePreview;
